import Base from '../Base';
import Component from 'vue-class-component';
import { Button, Badge } from 'streamlabs-beaker';
import {
  ESubscriptionPlanType,
  ICheckoutPlan,
} from '@/helpers/subscription';
import { Prop } from 'vue-property-decorator';
import { subscribeToUltra } from '@/helpers/streamlabs-ultra';
import { EAnalyticsEvent } from '@/helpers/analytic';
import SubscriptionApi from '@/apis/subscription-api';

@Component({
  components: {
    SButton: Button,
    SBadge: Badge,
  },
})
export default class CheckoutPlans extends Base {
  @Prop({ required: true })
  onNativeSubscriptionClick: () => void;

  get planData(): ICheckoutPlan[] {
    return [
      {
        id: 'pro',
        name: 'Console Pro',
        prices: `$${this.monthlyPrice}/mo or $${this.annualPrice}/yr`,
        logo: 'https://cdn.streamlabsstudio.com/static/logos/streamlabs-console-logo.png',
        badgeVariation: 'new',
        badgeText: 'Most Popular',
        perks: [
          'Broadcast from Xbox with ease',
          'Customize multiple Scenes',
          // 'Access Overlay Themes',
          'Multistream to Twitch, YouTube, and more',
          // 'Dual Output horizontal and vertical streams',
        ],
        isExpanded: !this.isMobile,
      },
      {
        id: 'ultra',
        name: 'Streamlabs Ultra',
        prices: '$27/mo or $189/yr',
        logo: 'https://cdn.streamlabs.com/static/imgs/library/slone/ultra-brand-icons.png',
        badgeVariation: 'beta',
        badgeText: 'Best Value',
        perks: [
          'Everything in Console Pro',
          'Plus <b>Ultra</b> features across all Streamlabs tools:',
          'Overlay Library in Desktop, Mobile, & more',
          'Multistream from all devices',
          'Premium Clipping & Editing tools',
          'Custom Tip Page & domain name',
        ],
        isExpanded: !this.isMobile,
      },
    ];
  };

  async mounted() {
    if (!this.plans) {
      const planResponse = await SubscriptionApi.getPlans();
      this.plans = planResponse.data.plans;
      if (planResponse.data.group)
        this.userModule.setABGroup(planResponse.data.group);
      this.$sla.sendEvent(EAnalyticsEvent.impression);
    }
  }

  get buttonText(): string {
    return !this.userSubscription ? 'Start free trial' : 'Select plan';
  }

  get monthlyPrice(): number {
    return Math.ceil((this.plans[ESubscriptionPlanType.monthly].price) / 100);
  }

  get annualPrice(): number {
    return Math.ceil((this.plans[ESubscriptionPlanType.annual].price) / 100);
  }

  toggleExpand(plan: ICheckoutPlan) {
    this.planData.find((p) => p.id === plan.id)!.isExpanded = !plan.isExpanded;
  }

  onSelectPlan(planId: 'pro' | 'ultra') {
    if (planId === 'pro') {
      this.onNativeSubscriptionClick();
      return;
    }

    this.onBuyNow();
  }

  async onBuyNow() {
    try {
      this.$sla.sendEvent(EAnalyticsEvent.ultraBannerClicked);

      await subscribeToUltra(!this.userSubscription);
    } finally {
      // forcefully reload the user to make sure we have the FE updated.
      // Currently there's no callback for user connecting on Ultra checkout page
      // Only window close event
      await this.loadUser(true);
    }
  }
}
